module.exports = __webpack_public_path__ + "img/390.5a54ae56.png";